import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { CustomEase } from 'gsap/CustomEase'

gsap.registerPlugin(SplitText, ScrollTrigger, CustomEase)
CustomEase.create('osmo', '0.625, 0.05, 0, 1')

const splitConfig = {
    lines: { duration: 0.8, stagger: 0.08 },
    words: { duration: 0.6, stagger: 0.06 },
    chars: { duration: 0.4, stagger: 0.01 }
}

export function initMaskTextScrollReveal(container = null) {
    const containerEl = container ?? document
    containerEl
        .querySelectorAll('[data-split="heading"]')
        .forEach((heading) => {
            // console.log(heading)
            // Find the split type, the default is 'lines'
            const type = heading.dataset.splitReveal || 'lines'
            const typesToSplit =
                type === 'lines'
                    ? ['lines']
                    : type === 'words'
                      ? ['lines', 'words']
                      : ['lines', 'words', 'chars']

            // Split the text
            SplitText.create(heading, {
                type: typesToSplit.join(', '), // split into required elements
                mask: 'lines', // wrap each line in an overflow:hidden div
                autoSplit: true,
                linesClass: 'line',
                wordsClass: 'word',
                charsClass: 'letter',
                onSplit: function (instance) {
                    const targets = instance[type] // Register animation targets
                    const config = splitConfig[type] // Find matching duration and stagger from our splitConfig

                    return gsap.from(targets, {
                        yPercent: 110,
                        duration: config.duration,
                        stagger: config.stagger,
                        ease: 'osmo',
                        scrollTrigger: {
                            trigger: heading,
                            start: 'clamp(top 90%)',
                            once: true
                            // markers: true
                        }
                    })
                }
            })
        })
}

// document.addEventListener('DOMContentLoaded', () => {
//     initMaskTextScrollReveal()
// })
